module.exports = __webpack_public_path__ + "img/grey.f6e70cf9.png";